import React from "react"
import Pin from "./Pin"

const Map = ({ location, venue_id }) => {
  // const lat = location.latitude
  // const lng = location.longitude
  // const zoom = 15

  const width = 1600
  const height = 800

  let mapUrl = '';
  let directionsUrl = '';
  
  if (venue_id == 5) {

    // Art
    mapUrl = '/art-visit.png';
    directionsUrl = 'https://maps.app.goo.gl/mwdeyW6714hee3ET6';
  
  } else if (venue_id == 3) {

    // Making
    mapUrl = '/making-visit.png';
    directionsUrl = 'https://maps.app.goo.gl/oc6XPZMH7oPHNgmG6';
  
  } else if (venue_id == 4) {

    // Pickford
    mapUrl = '/pickford-visit.png';
    directionsUrl = 'https://maps.app.goo.gl/ikCXiETmHb4MjcRQ8';
    
  }

  return (
    <div style={{ position: "relative", height: `${height}px`, width: `${width}px` }} className="googleMapIframe">
      <a href={directionsUrl} target="_blank" rel="noopener noreferrer">
        <img
          src={mapUrl}
          alt="Static Google Map"
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      </a>

      <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
        <Pin />
      </div>



    </div>
  )
}

export default Map
